import React, { ChangeEvent, FC, useState } from "react";
import "./Form.css";

interface ApiResponse<T> {
  statusCode: number;
  success: boolean;
  body: {
    data: T;
    message: string;
  };
}

interface SubmittedData {
  name: string;
  email: string;
  phone: string;
  message: string;
  state: string;
  street: string;
  city: string;
  zip: string;
  country: string;
}

const Form: FC = () => {
  const [result, setResult] = useState("");

  const onSubmit = async (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    setResult("Sending....");
    const formData: FormData = new FormData(event.target);

    formData.append("access_key", "3497f864-e6d7-4ac9-91a5-67d6c7fcfad4");

    const response: Response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data: ApiResponse<SubmittedData> = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      (event.target as HTMLFormElement).reset();
    } else {
      console.log("Error", data);
      setResult(data.body.message || "An error occurred");
    }
  };

  return (
    <>
      <form className="subscription-form" onSubmit={onSubmit}>
        <input type="text" name="name" placeholder="Name" required />
        <div className="subscription-info-inputs">
          <input type="email" name="email" placeholder="Email" required className=""/>
          <input type="tel" name="phone" placeholder="Phone" required />
          <input type="" name="street" placeholder="Street address" required />
          <input type="tel" name="city" placeholder="City" required />
          <input type="tel" name="state" placeholder="State/Province" required />
          <input type="tel" name="zip" placeholder="Zip Code" required />
        </div>
        <textarea name="message" placeholder="Your message" required></textarea>



        <button className="submit-button" type="submit">
          SEND
        </button>
      </form>
      <span className="result-message">{result}</span>
    </>
  );
};

export default Form;
